import { ref } from 'vue';

import type { RescheduleAnswer } from '@/utils/plan-node-reschedule';

export interface RescheduleAskState {
  title: string;
  fromDay: string | null;
  toDay: string | null;
  /** 一次问多条（批量、顺延、AI 排期）时写几条 */
  count: number;
  resolve: (answer: RescheduleAnswer | null) => void;
}

/**
 * 「改期要写原因」的弹窗状态（0926）。三个页面（阶段工作、计划甘特、AI 排期）共用：
 * `ask()` 返回一个 Promise，弹窗确认就 resolve 原因，取消 resolve null；
 * 同一时刻只留一个，连问两次时前一个按取消处理。
 */
export function useRescheduleAsk() {
  const pending = ref<RescheduleAskState | null>(null);

  function ask(input: Omit<RescheduleAskState, 'resolve' | 'count'> & { count?: number }): Promise<RescheduleAnswer | null> {
    return new Promise((resolve) => {
      pending.value?.resolve(null);
      pending.value = { ...input, count: input.count ?? 1, resolve };
    });
  }

  function settle(answer: RescheduleAnswer | null): void {
    const current = pending.value;
    pending.value = null;
    current?.resolve(answer);
  }

  return { pending, ask, settle };
}
